
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import { ValidationProvider, extend } from 'vee-validate';
import { required } from 'vee-validate/dist/rules';

extend('required', {
  ...required,
  message: 'This field is required',
});

import { lookupCustomer } from '@/api';
import _debounce from 'lodash/debounce';
@Component({
  components: {
    ValidationProvider,
  },
})
export default class LookupCustomerCode extends Vue {
  @Prop({ type: String, required: true }) public customer: string;

  public loading = false;

  public codeValue = '';
  public selectItems: string[] = [];

  public showOptions = false;
  public codeChosen = '';
  public arrowIdx = -1;

  public debouncedLookup = _debounce(this.fetchCustomerData, 150);

  @Watch('codeChosen', { deep: true })
  private watchCodeChosen() {
    this.$emit('changed', this.codeChosen);
  }

  public async fetchCustomerData(): Promise<void> {
    if (this.codeValue.length >= 1) {
      this.loading = true;
      await lookupCustomer({
        customer_code: this.codeValue,
      })
        .then(data => {
          this.selectItems = data;
        })
        .catch(e => console.log(e))
        .finally(() => {
          this.loading = false;
        });
    }
  }

  public async handleInput(evt: string): Promise<void> {
    if (evt || evt === '') {
      this.codeValue = evt;
    }
    if (this.codeValue.length >= 1) {
      this.debouncedLookup();
    }
  }

  public inputKeyPressed(evt: KeyboardEvent): void {
    // Open dropdown on Focus
    if (!this.showOptions) {
      this.showOptions = true;
      this.arrowIdx = -1;
    }
    // Close dropdown when "Escape" pressed
    if (evt.code === 'Escape') {
      this.showOptions = false;
      this.arrowIdx = -1;
    }
    // ArrowDown / ArrowUp pressed
    if (evt.code === 'ArrowDown' && this.arrowIdx < this.selectItems.length - 1) {
      this.arrowIdx += 1;
      this.fixScrolling();
    }
    if (evt.code === 'ArrowUp' && this.arrowIdx >= 1) {
      this.arrowIdx -= 1;
      this.fixScrolling();
    }
    // Enter pressed
    if (evt.code === 'Enter' && this.arrowIdx >= 0) {
      evt.preventDefault();
      this.codeChosen = this.selectItems[this.arrowIdx];
      this.showOptions = false;
      this.codeValue = this.selectItems[this.arrowIdx];
      this.arrowIdx = -1;
    }
  }

  private fixScrolling() {
    const options = this.$refs.options as HTMLFormElement;
    const scrollContainer = this.$refs.scrollContainer as HTMLFormElement;
    if (options && scrollContainer) {
      const liH = options[this.arrowIdx].clientHeight;
      scrollContainer.scrollTop = liH * this.arrowIdx;
    }
  }

  public clearInput(): void {
    this.codeValue = '';
    this.showOptions = false;
    this.codeChosen = '';
    this.arrowIdx = -1;
    this.selectItems = [];
  }

  public inputFocused(): void {
    this.showOptions = true;
  }

  public inputBlured(): void {
    setTimeout(() => {
      this.showOptions = false;
      if (!this.codeChosen) {
        this.codeValue = '';
      } else {
        this.codeValue = this.codeChosen;
      }
    }, 200);
  }

  public handleItemClick(item: string): void {
    this.codeChosen = item;
    this.showOptions = false;
    this.codeValue = item;
  }

  public clickedOutside(): void {
    this.showOptions = false;
  }

  private mounted() {
    this.codeValue = this.customer;
  }
}
